import React from 'react';
import RadiusInput from 'components/common/formElements/radiusInput';
import Form from 'components/common/formElements/form';
import buttons from 'style/buttons.module.scss';
import * as yup from 'yup';
import _ from 'lodash';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import { updateEmailUser } from 'actions/users';
import { IChangeUserEmailChange } from 'types';
import styles from './index.module.scss';

interface IProps {
  currentEmail: string;
  error: string[];
}

const ChangeEmail: React.FC<IProps> = ({ currentEmail, error }) => {
  const dispatch = useDispatch();

  const schema = yup.object().shape({
    newEmail: yup.string().email().required(),
  });

  const { register, handleSubmit, errors, reset } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = async (values: IChangeUserEmailChange) => {
    await dispatch(updateEmailUser(values.newEmail));
    reset();
  };
  return (
    <>
      <div className={styles.changeField}>
        <div className={styles.header}>
          <span>Email</span>
          <p>You can change your email</p>
        </div>
        <div className={styles.inputBlock}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <RadiusInput
              variant="outlined"
              type="text"
              // label="Current email"
              name="currentEmail"
              value={currentEmail}
              disabled
            />
            <RadiusInput
              variant="outlined"
              type="text"
              label="New E-mail"
              name="newEmail"
              ref={register}
              error={!!errors.newEmail}
            />
            {!_.isEmpty(error) &&
              error.map((err) => (
                <span className="error-message" key={err}>
                  {err}
                </span>
              ))}
            <button type="submit" className={buttons.buttonBlue}>
              Save Changes
            </button>
          </Form>
        </div>
      </div>
    </>
  );
};
export default ChangeEmail;
